import Image from 'next/image'

import useMediaQuery from '@equifax-ui/hooks/useMediaQuery'

import { RoundIcon } from '@/components'

import { Actions } from '..'

import styles from './Solution.module.scss'

export const Solution = ({ visibleService, onClickAction }) => {
  const isDesktop = useMediaQuery('screen and (min-width: 1024px)')

  return (
    <div className={styles.solution}>
      <div className={styles.solution__title}>
        <RoundIcon
          size="medium"
          iconColor="primary"
          bgColor="shadowed"
          icon={visibleService.icon}
        />

        <h3>{visibleService.title}</h3>
      </div>

      <p className={styles.solution__subtitle}>{visibleService.description}</p>

      <div className={styles.solution__content}>
        <div>
          {visibleService.details && (
            <div className={styles.solution__details}>
              {visibleService.details}
            </div>
          )}

          {visibleService.actions_type && (
            <Actions
              type={visibleService.actions_type}
              onClick={onClickAction}
            />
          )}
        </div>

        {isDesktop && (
          <Image
            loading="lazy"
            width={256}
            height={240}
            src={visibleService.img}
            alt="imagem ilustrativa sobre a solução"
          />
        )}
      </div>
    </div>
  )
}
